import React, { useCallback } from 'react';
import { Dropdown } from 'react-bootstrap';
import shallow from 'zustand/shallow';
import { EventType as Event } from '../../graphql';
import { useEventsStore } from '../../store';

export const EventType = ({ className }: { className?: string }): React.ReactElement => {
  const { evType, setEvType } = useEventsStore((v) => ({
    evType: v.filters.eventType,
    setEvType: v.setEventType
  }), shallow);

  const selectEventType = useCallback(
    (type: typeof evType) => (): void => {
      setEvType(type);
    },
    [setEvType]
  );

  return (
    <Dropdown>
      <Dropdown.Toggle variant={evType ? 'secondary' : 'outline-lightgrey'} className={className}>
        Event Type
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item active={evType === undefined} onSelect={selectEventType(undefined)}>
          All Events
        </Dropdown.Item>
        <Dropdown.Item
          active={evType === Event.Produced}
          onSelect={selectEventType(Event.Produced)}
        >
          Produced
        </Dropdown.Item>
        <Dropdown.Item active={evType === Event.Static} onSelect={selectEventType(Event.Static)}>
          Static
        </Dropdown.Item>
        <Dropdown.Item active={evType === Event.Mobile} onSelect={selectEventType(Event.Mobile)}>
          Mobile
        </Dropdown.Item>
        <Dropdown.Item active={evType === Event.MobileKit} onSelect={selectEventType(Event.MobileKit)}>
          Mobile Kit
        </Dropdown.Item>
        <Dropdown.Item active={evType === Event.SimLive} onSelect={selectEventType(Event.SimLive)}>
          Simulated Live
        </Dropdown.Item>
        <Dropdown.Item active={evType === Event.Test} onSelect={selectEventType(Event.Test)}>
          Test
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
